import TARTGET_SLIDER1 from './target/slider1.jpeg';
import TARTGET_SLIDER2 from './target/slider2.jpeg';
import TARTGET_SLIDER3 from './target/slider3.jpeg';
import TARTGET_SLIDER4 from './target/slider4.jpeg';
import TARTGET_SLIDER5 from './target/slider5.jpeg';
import TARTGET_SLIDER6 from './target/slider6.jpeg';
import TARTGET_SLIDER7 from './target/slider7.jpeg';
import TARTGET_SEC1 from './target/sec1.png';
import TARTGET_SEC2 from './target/sec2.jpeg';
import TARTGET_SEC3 from './target/sec3.jpeg';
import TARTGET_SEC4 from './target/sec4.jpeg';

import SHIPBOARD_SLIDER1 from './target/slider1.jpeg';
import SHIPBOARD_SLIDER2 from './target/slider2.jpeg';
import SHIPBOARD_SLIDER3 from './target/slider3.jpeg';
import SHIPBOARD_SLIDER4 from './target/slider4.jpeg';
import SHIPBOARD_SLIDER5 from './target/slider5.jpeg';
import SHIPBOARD_SLIDER6 from './target/slider6.jpeg';
/* import SHIPBOARD_SEC1 from './target/sec1.png';
import SHIPBOARD_SEC2 from './target/sec2.jpeg';
import SHIPBOARD_SEC3 from './target/sec3.jpeg';
import SHIPBOARD_SEC4 from './target/sec4.jpeg'; */

import EQUIPMENT_SLIDER1 from './equipment/slider1.jpeg';
import EQUIPMENT_SLIDER2 from './equipment/slider2.jpeg';
import EQUIPMENT_CENTRAL from './equipment/central.png';
/* import EQUIPMENT_SEC1 from './equipment/sec1.jpeg';
import EQUIPMENT_SEC2 from './equipment/sec2.png';
import EQUIPMENT_SEC3 from './equipment/sec3.jpeg';
import EQUIPMENT_SEC4 from './equipment/sec4.jpeg'; */

import INDUSTRIAL_TOP from './industrial/top.png';
import INDUSTRIAL_CARD1 from './industrial/card1.jpeg';
import INDUSTRIAL_CARD2 from './industrial/card2.png';
import INDUSTRIAL_CARD3 from './industrial/card3.png';
import INDUSTRIAL_CARD4 from './industrial/card4.png';
import INDUSTRIAL_CARD5 from './industrial/card5.png';
import INDUSTRIAL_PDF1 from './industrial/CAPANNONIPERSABBIATURAEVERNICIATURA.pdf';
import INDUSTRIAL_PDF2 from './industrial/NUOVAOFFICINAELOCALIACCESSORI.pdf';
import INDUSTRIAL_PDF3 from './industrial/DESIGNECOSTRUZIONEDIUNNUOVOEDIFICIOADIBITOAUFFICIESPOGLIATOI.pdf';
import INDUSTRIAL_PDF4 from './industrial/RINNOVODEGLIUFFICI.pdf';
import INDUSTRIAL_PDF5 from './industrial/LAVORICOMPLEMENTARIPERMESSAINSICUREZZABACINODICARENAGGIODA150.000TPL.pdf';
/* import INDUSTRIAL_SEC1 from './industrial/sec1.jpeg';
import INDUSTRIAL_SEC2 from './industrial/sec2.png';
import INDUSTRIAL_SEC3 from './industrial/sec3.jpeg';
import INDUSTRIAL_SEC4 from './industrial/sec4.jpeg'; */

import LIFECYCLE_TOP from './lifecycle/top.png';
import LIFECYCLE_CENTRAL from './lifecycle/central.png';
/* import LIFECYCLE_SEC1 from './lifecycle/sec1.jpeg';
import LIFECYCLE_SEC2 from './lifecycle/sec2.png';
import LIFECYCLE_SEC3 from './lifecycle/sec3.jpeg';
import LIFECYCLE_SEC4 from './lifecycle/sec4.jpeg'; */

import PROPULSION_TOP from './propulsion/top.png';
import PROPULSION_CARD1 from './propulsion/card1.png';
import PROPULSION_CARD2 from './propulsion/card2.png';
import PROPULSION_CARD3 from './propulsion/card3.png';
import PROPULSION_PDF1 from './propulsion/LHDeng.pdf';
import PROPULSION_PDF2 from './propulsion/LSSeng.pdf';
import PROPULSION_PDF3 from './propulsion/PPAeng.pdf';
import PROPULSION_SEC1 from './propulsion/sec1.png';
import PROPULSION_SEC2 from './propulsion/sec2.jpeg';
import PROPULSION_SEC3 from './propulsion/sec3.jpeg';

import ENERGY_TOP from './energy/top.png';
import ENERGY_SIDE from './energy/side.jpeg';
import ENERGY_CARD from './energy/card1.jpeg';
import ENERGY_PDF from './energy/FincantieriSI_GrimaldiCruises.pdf';
// import ENERGY_SEC1 from './energy/sec1.jpeg';
import ENERGY_SEC2 from './energy/sec2.jpeg';
import ENERGY_SEC3 from './energy/sec3.jpeg';

import ELECTRO_TOP from './electro/top.png';
import ELECTRO_SIDE from './electro/side.png';
import ELECTRO_CENTRAL from './electro/central.png';
import ELECTRO_CARD from './electro/card1.png';
import ELECTRO_PDF from './electro/Scheda_finca_Test_bench.pdf';
// import ELECTRO_SEC1 from './electro/sec1.jpeg';
import ELECTRO_SEC2 from './electro/sec2.png';
import ELECTRO_SEC3 from './electro/sec3.jpeg';

import SHIPTOSHORE_TOP from './shiptoshore/top.png';
import SHIPTOSHORE_CENTRAL from './shiptoshore/central.jpg';
// import SHIPTOSHORE_SEC1 from './shiptoshore/sec1.jpeg';
import SHIPTOSHORE_SEC2 from './shiptoshore/sec2.png';
import SHIPTOSHORE_SEC3 from './shiptoshore/sec3.jpeg';

import COLD_TOP from './cold/top.png';
import COLD_SIDE from './cold/side.jpeg';
import COLD_CENTRAL from './cold/central.jpeg';
import COLD_SEC1 from './cold/sec1.jpeg';
import COLD_SEC2 from './cold/sec2.png';
import COLD_SEC3 from './cold/sec3.jpeg';
import COLD_SEC4 from './cold/sec4.jpeg';

import LAND_TOP from './land/top.png';
import LAND_SIDE from './land/side.png';
// import LAND_SEC1 from './land/sec1.jpeg';
import LAND_SEC2 from './land/sec2.png';
import LAND_SEC3 from './land/sec3.jpeg';
import LAND_SEC4 from './land/sec4.jpeg';

export const targetEn = () => [
  {
    title: 'plants',
    internalTitle: 'Target',
    locale: 'en',
    content: {
      boxes: [
        {
          key: 'text',
          value:
            'Equipment and systems for land applications including equipment for shipyards, modular power plants and other systems.',
          image: {
            small: {
              id: '',
            },
          },
          pdf: {
            filename: '',
          },
        },
        {
          key: 'slogan',
          value: 'EXPERIENCE WITH HYBRID PROPULSION AND OTHER SYSTEMS',
          image: {
            small: {
              id: '',
            },
          },
          pdf: {
            filename: '',
          },
        },
      ],
    },
    slug: 'plants',
    status: 'draft',
    id: '609e729e1857c72bc4b9a793',
    original: '609250e55d346a5889989549',
    createdBy: '5fd33ab1be673ff370b4957e',
    updatedBy: null,
    createdAt: '2021-05-14T12:52:46.686Z',
    updatedAt: '2021-05-14T12:52:46.697Z',
    expireAt: null,
    revision: 5,
    active: true,
    channelFeatured: null,
    featured: null,
    roles: ['ADMIN', 'TECH', 'EDITOR'],
  },
  {
    title: 'shipboard',
    internalTitle: 'Target',
    locale: 'en',
    content: {
      boxes: [
        {
          key: 'text',
          value: 'MARINE AND NAVY SOLUTIONS',
          richText:
            '<p class="MsoNormal" style="text-align: justify; "><span lang="EN-US">SOLUTIONS AND SYSTEMS FOR PASSENGER VESSELS,\nCARGO VESSELS, NAVY SHIPS, FERRIES, SPECIAL VESSELS,\nOFF-SHORE VESSELS, TRAWLERS, TUGBOATS AND MEGA-YACHTS<o:p></o:p></span></p><p class="MsoNormal" style="text-align: justify;"><span lang="EN-US">&nbsp;</span></p><p class="MsoNormal" style="text-align: justify;"><span lang="EN-US"><strong>Innovation toward “smart vessel” solutions</strong><o:p></o:p></span></p><p style="text-align: justify; ">\n\n\n\n\n\n<span lang="EN-US" style="line-height: 107%;"><strong class="notOrange">FINCANTIERI SI</strong></span><span lang="EN-US" style="line-height: 107%;"> innovates by pursuing the idea of “smart vessel”.\nThis new type of ship incorporates advanced technology that\nbrings energy-efficiency savings with reduced environmental impact and greater comfort, both in navigation and in port.</span></p><p style="text-align: justify; "><br></p><p style="text-align: justify; "><strong>Electric generation and propulsion</strong></p><p style="text-align: justify; ">For all kind of ships and vessels <strong class="notOrange">FINCANTIERI SI </strong>provides:</p><ul><li style="text-align: justify;">Project management</li><li style="text-align: justify;">Electric system integration</li><li style="text-align: justify;">Grid analysis (THD, short-circuit)</li><li style="text-align: justify;">Diesel gensets</li><li style="text-align: justify;">LV &amp; MV electric distribution</li><li style="text-align: justify;">Distribution transformers</li><li style="text-align: justify;">Power transformers</li><li style="text-align: justify;">Variable frequency drives</li><li style="text-align: justify;">Thruster motors</li><li style="text-align: justify;">Propulsion motors</li></ul>',
          image: {
            small: {
              id: '',
            },
          },
          pdf: {
            filename: '',
          },
        },
        {
          key: 'sectionBox2',
          value: 'target/equipment',
          richText:
            '<p><span style="letter-spacing: 0.14px;">EQUIPMENT AND HARBOUR SYSTEMS</span><br></p>',
          image: TARTGET_SEC2,
          pdf: {
            filename: '',
          },
        },
        {
          key: 'sectionBox3',
          value: 'target/industrial',
          richText:
            '<p><span style="letter-spacing: 0.14px;">DESIGN AND INDUSTRIAL ENGINEERING</span><br></p>',
          image: TARTGET_SEC3,
          pdf: {
            filename: '',
          },
        },
        {
          key: 'sectionBox4',
          value: 'target/lifecycle',
          richText:
            '<p><span style="letter-spacing: 0.14px;">LIFECYCLE SERVICES</span><br></p>',
          image: TARTGET_SEC4,
          pdf: {
            filename: '',
          },
        },
        {
          key: 'slider1',
          value: '',
          richText: '',
          image: SHIPBOARD_SLIDER1,
          pdf: {
            filename: '',
          },
        },
        {
          key: 'slider2',
          value: '',
          richText: '',
          image: SHIPBOARD_SLIDER2,
          pdf: {
            filename: '',
          },
        },
        {
          key: 'slider3',
          value: '',
          richText: '',
          image: SHIPBOARD_SLIDER3,
          pdf: {
            filename: '',
          },
        },
        {
          key: 'slider4',
          value: '',
          richText: '',
          image: SHIPBOARD_SLIDER4,
          pdf: {
            filename: '',
          },
        },
        {
          key: 'slider5',
          value: '',
          richText: '',
          image: SHIPBOARD_SLIDER5,
          pdf: {
            filename: '',
          },
        },
        {
          key: 'slider6',
          value: '',
          richText: '',
          image: SHIPBOARD_SLIDER6,
          pdf: {
            filename: '',
          },
        },
      ],
    },
    slug: 'shipboard',
    status: 'draft',
    id: '60adfc7e2d582f4a763319e1',
    original: '6091202cd5b4fe324d3910fb',
    createdBy: '5fd33ab1be673ff370b4957e',
    updatedBy: null,
    createdAt: '2021-05-26T07:45:02.460Z',
    updatedAt: '2021-05-26T07:45:02.472Z',
    expireAt: null,
    revision: 11,
    active: true,
    featured: null,
    channelFeatured: null,
    roles: ['ADMIN', 'TECH', 'EDITOR'],
  },
  {
    title: 'energyship',
    internalTitle: 'Target',
    locale: 'en',
    content: {
      boxes: [
        {
          key: 'slogan',
          value: '',
          richText:
            '<p>BATTERIES PACKS FOR ENERGY STORAGE MANAGED BY POWER CONTROL AND AUTOMATION SYSTEMS<br></p>',
          image: {
            small: {
              id: ENERGY_TOP,
            },
          },
          pdf: {
            filename: '',
          },
        },
        {
          key: 'text',
          value: 'ENERGY STORAGE SYSTEMS: MAIN FUNCTIONALITIES',
          richText:
            '<p class="MsoNormal" style="text-align:justify"><span lang="EN-US">An Energy Storage System can provide many functionalities for the onboard electrical system:</span></p><ul> <li style="text-align: justify;"><span style="font-family: Lato; letter-spacing: 0.14px; text-indent: -24px;">Spinning Reserve;</span></li> <li style="text-align: justify;"><span style="font-family: Lato; letter-spacing: 0.14px; text-indent: -24px;">Blackout Prevention;</span></li> <li style="text-align: justify;"><span style="font-family: Lato; letter-spacing: 0.14px; text-indent: -24px;">Peak Shaving and Load Levelling;</span></li> <li style="text-align: justify;"><span style="font-family: Lato; letter-spacing: 0.14px; text-indent: -24px;">Network Resilience and Stability;</span></li> <li style="text-align: justify;"><span style="font-family: Lato; letter-spacing: 0.14px; text-indent: -24px;">Harbor Operations, preventing ships using diesel generators.<br></span></li></ul><p style="text-align: justify;">\n\n\n\n\n\n\n\n<span style="font-family: Lato; letter-spacing: 0.14px;"><br></span></p><p class="MsoNormal" style="text-align:justify"><span lang="EN-US">The ESS for any marine application is built around key concepts:</span></p><ul> <li style="text-align: justify;"><span style="font-family: Lato; letter-spacing: 0.14px; text-indent: -24px;">Scalability to upper/lower power/energy requirements, thanks to its modularity;</span></li> <li style="text-align: justify;"><span style="font-family: Lato; letter-spacing: 0.14px; text-indent: -24px;">Customizability to the operating mode, thanks to the FINCANTIERI SI’s Energy Management System;</span></li> <li style="text-align: justify;"><span style="font-family: Lato; letter-spacing: 0.14px; text-indent: -24px;">Flexibility in interconnecting to the existing onboard systems. </span></li></ul><p style="text-align: justify;">\n\n\n\n\n\n\n\n<span style="font-family: Lato; letter-spacing: 0.14px;"><br></span></p>',
          image: {
            small: {
              id: ENERGY_SIDE,
            },
          },
          pdf: {
            filename: '',
          },
          noBrackets: true,
        },
        {
          key: 'card',
          value: 'ENERGY STORAGE SYSTEM FOR SHIPS (ESS) – Grimaldi Cruises',
          richText:
            '<div style="">Retrofit\nof two Ro-Pax ferries – Cruise Roma and Cruise Barcelona – to\nintroduce a unique «<strong>Zero Emission i<span lang="EN-US" style="line-height: 107%;">n\nport</span></strong><span lang="EN-US" style="line-height: 107%;">»\nconcept for the 254m-long, 63,000 GT vessels.</span>&nbsp;</div>',
          image: ENERGY_CARD,
          pdf: ENERGY_PDF,
          objectPosition: 'right',
        },
        {
          key: 'sectionBox1',
          value: 'target/shipboard/propulsion',
          richText: '<p>HYBRID PROPULSION</p>',
          image: COLD_SEC1,
          pdf: {
            filename: '',
          },
        },
        {
          key: 'sectionBox2',
          value: 'target/shipboard/electro',
          richText: '<p>ELECTRO-MECHANICAL SYSTEMS</p>',
          image: ENERGY_SEC2,
          pdf: {
            filename: '',
          },
        },
        {
          key: 'sectionBox3',
          value: 'target/shipboard/shiptoshore',
          richText: '<p>SHIP-TO-SHORE CONNECTION</p>',
          image: ENERGY_SEC3,
          objectPosition: 'right',
          pdf: {
            filename: '',
          },
        },
      ],
    },
    slug: 'energy',
    status: 'draft',
    id: '60ae52bf2d582f4a76331ec9',
    original: '60a4e77aa09e3808e5fd8dd3',
    createdBy: '5fd33ab1be673ff370b4957e',
    updatedBy: null,
    createdAt: '2021-05-26T13:53:03.327Z',
    updatedAt: '2021-05-26T13:53:03.337Z',
    expireAt: null,
    revision: 11,
    active: true,
    channelFeatured: null,
    roles: ['ADMIN', 'TECH', 'EDITOR'],
  },
  {
    title: 'shiptoshore',
    internalTitle: 'Target',
    locale: 'en',
    content: {
      boxes: [
        {
          key: 'slogan',
          value: '',
          richText:
            '<p><span style="line-height: 107%;">INNOVATIVE\nSMART POWER SOLUTIONS FOR SHIP CONNECTION TO HARBOUR ELECTRIC SUPPLY</span><br></p>',
          image: {
            small: {
              id: SHIPTOSHORE_TOP,
            },
          },
          pdf: {
            filename: '',
          },
        },
        {
          key: 'text',
          value: 'SHIP-TO-SHORE POWER SYSTEM',
          richText:
            '<p class="MsoNormal" style="text-align: justify; "><span lang="EN-US">The expertise of <strong>FINCANTIERI SI</strong> related\nto electric systems and equipment allows to provide turn-key solutions for\ndelivering power to ships at the </span><span lang="EN-GB">harbours so as to</span><span lang="EN-GB">\n</span><span lang="EN-US">switch off­ engines, reducing\nemissions in accordance to present regulations and protection of the\nenvironment.</span></p><p class="MsoNormal" style="text-align: justify;"><span lang="EN-US"><br></span></p><p class="MsoNormal" style="text-align: justify;"><span lang="EN-US"><strong>Power source for harbour operations</strong></span></p><p class="MsoNormal" style="text-align: justify;"><span lang="EN-US"><span lang="EN-US" style="line-height: 107%;">With\nreverse power transfer logics (from ship to shore) it is also possible to\nfeed temporary structures, like field hospital in case of need</span><strong><br></strong></span></p>',
          image: {
            small: {
              id: '',
            },
          },
          pdf: {
            filename: '',
          },
        },
        {
          key: 'central',
          value: '',
          richText: '',
          image: {
            small: {
              id: SHIPTOSHORE_CENTRAL,
            },
          },
          pdf: {
            filename: '',
          },
        },
        {
          key: 'sectionBox1',
          value: 'target/shipboard/propulsion',
          richText: '<p>HYBRID PROPULSION</p>',
          image: COLD_SEC1,
          pdf: {
            filename: '',
          },
        },
        {
          key: 'sectionBox2',
          value: 'target/shipboard/energy',
          richText: '<p>ENERGY STORAGE SYSTEMS</p>',
          image: SHIPTOSHORE_SEC2,
          pdf: {
            filename: '',
          },
          objectPosition: 'right',
        },
        {
          key: 'sectionBox3',
          value: 'target/shipboard/electro',
          richText: '<p>ELECTRO-MECHANICAL SYSTEMS</p>',
          image: SHIPTOSHORE_SEC3,
          pdf: {
            filename: '',
          },
        },
      ],
    },
    slug: 'ship',
    status: 'draft',
    id: '60ae52fe2d582f4a76331ef0',
    original: '60a510d9a09e3808e5fd8f29',
    createdBy: '5fd33ab1be673ff370b4957e',
    updatedBy: null,
    createdAt: '2021-05-26T13:54:06.789Z',
    updatedAt: '2021-05-26T13:54:06.802Z',
    expireAt: null,
    revision: 8,
    active: true,
    channelFeatured: null,
    featured: null,
    roles: ['ADMIN', 'TECH', 'EDITOR'],
  },
  {
    title: 'land',
    internalTitle: 'Target',
    locale: 'en',
    content: {
      boxes: [
        {
          key: 'text',
          value:
            'SOLUTIONS FOR ENERGY STORAGE SYSTEMS THANKS TO BATTERIES PACKS IN CONTAINERS',
          richText:
            '<p style="text-align: justify; "><b>Design, supply, installation and commissioning of container modules fro power supply and energy storage.</b></p><p>Battery Energy Storage Systems (BESS) to provide energy in support of the local network and also aimed at ultra-fast frequency regulation and the improvement of the dynamic response during the first moments of frequency transitions.</p>',
          image: {
            small: {
              id: LAND_SIDE,
            },
          },
          pdf: {
            filename: '',
          },
        },
        {
          key: 'slogan',
          value: '',
          richText:
            '<p>ENERGY STORAGE AND POWER SUPPLY FOR LAND APPLICATIONS<br></p>',
          image: {
            small: {
              id: LAND_TOP,
            },
          },
          pdf: {
            filename: '',
          },
        },
        {
          key: 'sectionBox1',
          value: 'target/shipboard/propulsion',
          richText: '<p>HYBRID PROPULSION</p>',
          image: COLD_SEC1,
          pdf: {
            filename: '',
          },
        },
        {
          key: 'sectionBox2',
          value: 'target/shipboard/energy',
          richText: '<p>ENERGY STORAGE SYSTEMS</p>',
          image: LAND_SEC2,
          objectPosition: 'right',
          pdf: {
            filename: '',
          },
        },
        {
          key: 'sectionBox3',
          value: 'target/shipboard/electro',
          richText: '<p>ELECTRO-MECHANICAL SYSTEMS</p>',
          image: LAND_SEC3,
          pdf: {
            filename: '',
          },
        },
        {
          key: 'sectionBox4',
          value: 'target/shipboard/shiptoshore',
          richText: '<p>SHIP-TO-SHORE CONNECTION</p>',
          image: LAND_SEC4,
          objectPosition: 'right',
          pdf: {
            filename: '',
          },
        },
      ],
    },
    slug: 'land',
    status: 'draft',
    id: '60ae533a2d582f4a76331f12',
    original: '6092517e5d346a5889989561',
    createdBy: '5fd33ab1be673ff370b4957e',
    updatedBy: null,
    createdAt: '2021-05-26T13:55:06.843Z',
    updatedAt: '2021-05-26T13:55:06.863Z',
    expireAt: null,
    revision: 13,
    active: true,
    channelFeatured: null,
    featured: null,
    roles: ['ADMIN', 'TECH', 'EDITOR'],
  },
  {
    title: 'industrial',
    internalTitle: 'Target',
    locale: 'en',
    content: {
      boxes: [
        {
          key: 'text',
          value: 'DESIGN AND INDUSTRIAL ENGINEERING',
          richText:
            '<p class="MsoNormal" style="text-align: justify; "> <span lang="EN-US"> FINCANTERI SI with Industrial Systems Engineering Business Unit, operates in the field of civil engineering, mainly providing design for civil works, complex industrial plants maritime and port infrastructure land reclamation and drainage, hydroelectric plants, fire prevention systems and electromechanical works, developing activities engineering and consulting, such as: <o:p></o:p> </span></p><ul> <li style=""><span style="text-indent: -24px;">Technical and economic feasibility studies</span></li> <li style=""><span style="text-indent: -24px;">Procedures and authorizations management</span></li> <li style=""><span style="text-indent: -24px;">Preliminary and final design</span></li> <li style=""><span style="text-indent: -24px;">Commissioning and start-up</span></li> <li style=""><span style="text-indent: -24px;">Construction management and supervision&nbsp;</span></li> <li style=""><span style="text-indent: -24px;">Safety coordination at design and executive phase<br></span>&nbsp;</li></ul><p class="MsoNormal" style="text-align: justify; "> <span lang="EN-US">To operate in this field, FINCANTIERI SI has gained and developed specific engineering skills and know-how aimed to complete start-to-finish design and development of a project. <o:p></o:p> </span></p><p class="MsoNormal" style="text-align: justify; "> <span lang="EN-US">Our team, with a balanced mix of seniority, has the appropriate experience in the fields of civil and industrial engineering, structural design (both in reinforced concrete and carpentry), and regulations of fire, building construction, environmental and safety of building, plants and construction sites. <o:p></o:p> </span></p>',
          image: {
            small: {
              id: '',
            },
          },
          pdf: {
            filename: '',
          },
        },
        {
          key: 'slogan',
          value: '',
          richText:
            '<p>INNOVATION AND ECO-SUSTAINABLE SOLUTIONS IN THE FIELD OF CIVIL AND INDUSTRIAL ENGINEERING<br></p>',
          image: {
            small: {
              id: INDUSTRIAL_TOP,
            },
          },
          pdf: {
            filename: '',
          },
        },
        {
          key: 'card',
          value: '',
          richText:
            '<p class="MsoNormal" style=""><span lang="EN-US"><strong>SANDBLASTING AND PAINTING SHEDS </strong><o:p></o:p></span></p><p>\n\n<span lang="EN-US" style="line-height: 107%;">The sheds, at the forefront of new technologies,\nare designed for vessel metal structures precise sandblasting and painting,\nmaking use of a high level of innovation: the process is in fact regulated by\ncustomized m</span>anagement\nsystems.&nbsp;</p>',
          image: INDUSTRIAL_CARD1,
          pdf: INDUSTRIAL_PDF1,
        },
        {
          key: 'card',
          value: '',
          richText:
            '<p class="MsoNormal" style="text-align: justify; "><span lang="EN-US"><strong>NEW\nWORKSHOP AND ACCESSORY WORKPSPACES</strong><o:p></o:p></span></p><p style="text-align: justify; ">\n\n<span lang="EN-US" style="line-height: 107%;">Construction of 14.600 sqm and 33m high new\nbuilding used as workshop and ancillary rooms in the FINCANTIERI quay in Marghera.<br></p>',
          image: INDUSTRIAL_CARD2,
          pdf: INDUSTRIAL_PDF2,
        },
        {
          key: 'card',
          value: '',
          richText:
            '<p class="MsoNormal" style="text-align: justify; "><span lang="EN-US"><strong>NEW BUILDING FOR OFFICES AND LOCKER ROOMS</strong><o:p></o:p></span></p><p style="text-align: justify; ">\n\n<span lang="EN-US" style="line-height: 107%;">design and construction of a 1600 sqm 3 floors\nbuilding used as offices and locker rooms in the FINCANTIERI q</span>uay\nin Marghera.&nbsp;</p>',
          image: INDUSTRIAL_CARD3,
          pdf: INDUSTRIAL_PDF3,
        },
        {
          key: 'card',
          value: '',
          richText:
            '<p class="MsoNormal" style="text-align: justify; "><span lang="EN-US"><strong>OFFICE RENOVATION</strong><o:p></o:p></span></p><p class="MsoNormal" style="text-align: justify;">\n\n<span lang="EN-US" style="line-height: 107%;">review of the internal layout of the offices\nlocated on the second floor of the west wing of Building 66 of the FINCANTIERI quay in Monfalcone.&nbsp;</p>',
          image: INDUSTRIAL_CARD4,

          pdf: INDUSTRIAL_PDF4,
        },
        {
          key: 'card',
          value: '',
          richText:
            '<p class="MsoNormal" style="text-align: justify; "><span lang="EN-US"><strong>COMPLEMENTARY\nWORKS FOR 150,000 DWT DRY DOCK SECURING </strong><o:p></o:p></span></p><p style="text-align: justify; ">\n\n<span lang="EN-US" style="line-height: 107%;">The project is part of the 2017-2019 Three-Year\nOperational Plan of the Port Authority “Mare di Sicilia Occidentale” (AdSPMSO)\nfor the implementation of numerous interventions aimed at the general</span>eorganization\nof Palermo Port, in order to enhance the shipbuilding and the production\ncapacity of the site.<br></p>',
          image: INDUSTRIAL_CARD5,
          pdf: INDUSTRIAL_PDF5,
        },
        {
          key: 'sectionBox1',
          value: 'target/shipboard',
          richText:
            '<p><span style="line-height: 107%;">MARINE\nSOLUTIONS AND SHIPBOARD SYSTEMS</span><br></p>',
          image: TARTGET_SEC1,
          pdf: {
            filename: '',
          },
          objectPosition: 'right',
        },
        {
          key: 'sectionBox2',
          value: 'target/equipment',
          richText:
            '<p><span style="letter-spacing: 0.14px;">EQUIPMENT AND HARBOUR SYSTEMS</span><br></p>',
          image: TARTGET_SEC2,
          pdf: {
            filename: '',
          },
        },
        {
          key: 'sectionBox4',
          value: 'target/lifecycle',
          richText:
            '<p><span style="letter-spacing: 0.14px;">LIFECYCLE SERVICES</span><br></p>',
          image: TARTGET_SEC4,
          pdf: {
            filename: '',
          },
        },
      ],
    },
    slug: 'industrial',
    status: 'draft',
    id: '60ae535a2d582f4a76331f1d',
    original: '609251e75d346a5889989579',
    createdBy: '5fd33ab1be673ff370b4957e',
    updatedBy: null,
    createdAt: '2021-05-26T13:55:38.993Z',
    updatedAt: '2021-05-26T13:55:39.009Z',
    expireAt: null,
    revision: 14,
    active: true,
    channelFeatured: null,
    featured: null,
    roles: ['ADMIN', 'TECH', 'EDITOR'],
  },
  {
    title: 'lifeCycle',
    internalTitle: 'Target',
    locale: 'en',
    content: {
      boxes: [
        {
          key: 'slogan',
          value: '',
          richText:
            '<p><span style="line-height: 107%;">COMPLETE\nLIFECYCLE SERVICE TO SUPPORT CLIENTS THROUGHOUT THE ENTIRE SHIP AND\nINFRASTRUCTURE LIFE&nbsp;</span><br></p>',
          image: {
            small: {
              id: LIFECYCLE_TOP,
            },
          },
          pdf: {
            filename: '',
          },
        },
        {
          key: 'text',
          value: 'COMPLETE LIFECYCLE SERVICE',
          richText:
            '<p class="MsoNormal" style="text-align: justify; "><span lang="EN-US">FINCANTIERI SI <span lang="EN-US">’s operating model is highly integrated, with\nan exchange of expertise to support Clients throughout the entire ship,\nequipment and infrastructure’s lifecycle. Service and maintenance activities,\nalso supported by remote control and monitoring, cover electrical and\nautomation systems, as well as key components.<o:p></o:p></span></p><p class="MsoNormal" style="text-align: justify;">\n\n<span lang="EN-US" style="line-height: 107%;">Revamping and maintenance of technological\nsystems, heavy equipment, cranes, lifting and complex systems with planning of\ninterventions (preventive, predictive and corrective maintenance services) and\nfocus on service management with the aim to optimize:</span><br></p>',
          image: {
            small: {
              id: '',
            },
          },
          pdf: {
            filename: '',
          },
        },
        {
          key: 'central',
          value: '',
          richText: '',
          image: {
            small: {
              id: LIFECYCLE_CENTRAL,
            },
          },
          pdf: {
            filename: '',
          },
        },
        {
          key: 'sectionBox1',
          value: 'target/shipboard',
          richText:
            '<p><span style="line-height: 107%;">MARINE\nSOLUTIONS AND SHIPBOARD SYSTEMS</span><br></p>',
          image: TARTGET_SEC1,
          objectPosition: 'right',
          pdf: {
            filename: '',
          },
        },
        {
          key: 'sectionBox2',
          value: 'target/equipment',
          richText:
            '<p><span style="letter-spacing: 0.14px;">EQUIPMENT AND HARBOUR SYSTEMS</span><br></p>',
          image: TARTGET_SEC2,
          pdf: {
            filename: '',
          },
        },
        {
          key: 'sectionBox3',
          value: 'target/industrial',
          richText:
            '<p><span style="letter-spacing: 0.14px;">DESIGN AND INDUSTRIAL ENGINEERING</span><br></p>',
          image: TARTGET_SEC3,
          pdf: {
            filename: '',
          },
        },
      ],
    },
    slug: 'lifecycle',
    status: 'draft',
    id: '60ae536e2d582f4a76331f28',
    original: '60ab6a132d582f4a763308df',
    createdBy: '5fd33ab1be673ff370b4957e',
    updatedBy: null,
    createdAt: '2021-05-26T13:55:58.887Z',
    updatedAt: '2021-05-26T13:55:58.900Z',
    expireAt: null,
    revision: 4,
    active: true,
    channelFeatured: null,
    roles: ['ADMIN', 'TECH', 'EDITOR'],
  },
  {
    title: 'equipment',
    internalTitle: 'Target',
    locale: 'en',
    content: {
      boxes: [
        {
          key: 'text',
          value: '',
          richText:
            '<p class="MsoNormal" style="text-align: justify; "><span lang="EN-US"><strong>FINCANTIERI SI</strong> provides equipment and systems for land applications including equipment for shipyards, modular power plants and other systems.<o:p></o:p></span></p>',
          image: {
            small: {
              id: '',
            },
          },
          pdf: {
            filename: '',
          },
        },
        {
          key: 'central',
          value: '',
          richText: '',
          image: {
            small: {
              id: EQUIPMENT_CENTRAL,
            },
          },
          pdf: {
            filename: '',
          },
        },
        {
          key: 'slider1',
          value: '',
          richText: '',
          image: EQUIPMENT_SLIDER1,
          pdf: {
            filename: '',
          },
        },
        {
          key: 'slider2',
          value: '',
          richText: '',
          image: EQUIPMENT_SLIDER2,
          pdf: {
            filename: '',
          },
        },
        {
          key: 'sectionBox1',
          value: 'target/shipboard',
          richText:
            '<p><span style="line-height: 107%;">MARINE\nSOLUTIONS AND SHIPBOARD SYSTEMS</span><br></p>',
          image: TARTGET_SEC1,
          objectPosition: 'right',
          pdf: {
            filename: '',
          },
        },
        {
          key: 'sectionBox3',
          value: 'target/industrial',
          richText:
            '<p><span style="letter-spacing: 0.14px;">DESIGN AND INDUSTRIAL ENGINEERING</span><br></p>',
          image: TARTGET_SEC3,
          pdf: {
            filename: '',
          },
        },
        {
          key: 'sectionBox4',
          value: 'target/lifecycle',
          richText:
            '<p><span style="letter-spacing: 0.14px;">LIFECYCLE SERVICES</span><br></p>',
          image: TARTGET_SEC4,
          pdf: {
            filename: '',
          },
        },
      ],
    },
    slug: 'equipment',
    status: 'draft',
    id: '60af4f2c2d582f4a763322ea',
    original: '60a513c3a09e3808e5fd8f9d',
    createdBy: '5fd33ab1be673ff370b4957e',
    updatedBy: null,
    createdAt: '2021-05-27T07:50:04.521Z',
    updatedAt: '2021-05-27T07:50:04.535Z',
    expireAt: null,
    revision: 8,
    active: true,
    channelFeatured: null,
    roles: ['ADMIN', 'TECH', 'EDITOR'],
  },
  {
    title: 'cold',
    internalTitle: 'Target',
    locale: 'en',
    content: {
      boxes: [
        {
          key: 'slogan',
          value: '',
          richText: '<p>PORT INFRASTRUCTURE FOR ZERO EMISSIONS<br></p>',
          image: {
            small: {
              id: COLD_TOP,
            },
          },
          pdf: {
            filename: '',
          },
        },
        {
          key: 'text',
          value: 'AN INTEGRATED ENERGY SYSTEM',
          richText:
            '<p class="MsoNormal" style="text-align: justify; "><span lang="EN-US">The\nintegration of storage and energy production systems at harbour level makes\npossible to manage user’s needs and to provide potential support to the\nnational grid.<o:p></o:p></span></p>',
          image: {
            small: {
              id: COLD_SIDE,
            },
          },
          pdf: {
            filename: '',
          },
          noBrackets: true,
        },
        {
          key: 'central',
          value: '',
          richText: '',
          image: {
            small: {
              id: COLD_CENTRAL,
            },
          },
          pdf: {
            filename: '',
          },
        },
        {
          key: 'sectionBox1',
          value: 'target/shipboard/propulsion',
          richText: '<p>HYBRID PROPULSION</p>',
          image: COLD_SEC1,
          pdf: {
            filename: '',
          },
        },
        {
          key: 'sectionBox2',
          value: 'target/shipboard/energy',
          richText: '<p>ENERGY STORAGE SYSTEMS</p>',
          image: COLD_SEC2,
          objectPosition: 'right',
          pdf: {
            filename: '',
          },
        },
        {
          key: 'sectionBox3',
          value: 'target/shipboard/electro',
          richText: '<p>ELECTRO-MECHANICAL SYSTEMS</p>',
          image: COLD_SEC3,

          pdf: {
            filename: '',
          },
        },
        {
          key: 'sectionBox4',
          value: 'target/shipboard/shiptoshore',
          richText: '<p>SHIP-TO-SHORE CONNECTION</p>',
          image: COLD_SEC4,
          objectPosition: 'right',
          pdf: {
            filename: '',
          },
        },
      ],
    },
    slug: 'cold',
    status: 'draft',
    id: '60af4ff12d582f4a76332336',
    original: '609935f01f6b1408dc7bb33b',
    createdBy: '5fd33ab1be673ff370b4957e',
    updatedBy: null,
    createdAt: '2021-05-27T07:53:21.314Z',
    updatedAt: '2021-05-27T07:53:21.325Z',
    expireAt: null,
    revision: 11,
    active: true,
    featured: null,
    channelFeatured: null,
    roles: ['ADMIN', 'TECH', 'EDITOR'],
  },
  {
    title: 'electro',
    internalTitle: 'Target',
    locale: 'en',
    content: {
      boxes: [
        {
          key: 'slogan',
          value: '',
          richText:
            '<p>FULL INTEGRATED ELECTRO-MECHANICAL SYSTEMS SUPPLIER<br></p>',
          image: {
            small: {
              id: ELECTRO_TOP,
            },
          },
          pdf: {
            filename: '',
          },
        },
        {
          key: 'text',
          value: 'FULL INTEGRATED ELECTRO-MECHANICAL SYSTEMS SUPPLIER',
          richText:
            '<p class="MsoNormal" style="text-align: justify; "><strong><span lang="EN-US" style="font-size: 10.5pt; line-height: 107%; font-family: Lato, serif; letter-spacing: 0.1pt; background-image: initial; background-position: initial; background-size: initial; background-repeat: initial; background-attachment: initial; background-origin: initial; background-clip: initial;">FINCANTIERI SI</span></strong><span lang="EN-US" style="font-size: 10.5pt; line-height: 107%; font-family: Lato, serif; letter-spacing: 0.1pt; background-image: initial; background-position: initial; background-size: initial; background-repeat: initial; background-attachment: initial; background-origin: initial; background-clip: initial;">&nbsp;handles the entire integrated electro-mechanical and electronic\npackage, off­ering to its Customers a turnkey product spanning the most\nsophisticated propulsion systems and the on-board electrical auxiliaries,\ndelivering project management, project engineering, construction and\ncommissioning, k</span><span style="font-size: 10.5pt; line-height: 107%; font-family: Lato, serif; letter-spacing: 0.1pt; background-image: initial; background-position: initial; background-size: initial; background-repeat: initial; background-attachment: initial; background-origin: initial; background-clip: initial;">ey hardware and software components, and lifecycle service.&nbsp;<o:p></o:p></span></p>',
          image: {
            small: {
              id: ELECTRO_SIDE,
            },
          },
          pdf: {
            filename: '',
          },
          noBrackets: true,
        },
        {
          key: 'card',
          value: 'TEST BENCH FOR A REDUCTION GEAR ASSEMBLY SITE',
          richText: '<p><br></p>',
          image: ELECTRO_CARD,
          pdf: ELECTRO_PDF,
        },
        {
          key: 'central',
          value: 'IMG CENTRAL',
          richText: '',
          image: {
            small: {
              id: ELECTRO_CENTRAL,
            },
          },
          pdf: {
            filename: '',
          },
        },
        {
          key: 'sectionBox1',
          value: 'target/shipboard/propulsion',
          richText: '<p>HYBRID PROPULSION</p>',
          image: COLD_SEC1,
          pdf: {
            filename: '',
          },
        },
        {
          key: 'sectionBox2',
          value: 'target/shipboard/energy',
          richText: '<p>ENERGY STORAGE SYSTEMS</p>',
          image: ELECTRO_SEC2,
          pdf: {
            filename: '',
          },
          objectPosition: 'right',
        },
        {
          key: 'sectionBox3',
          value: 'target/shipboard/shiptoshore',
          richText: '<p>SHIP-TO-SHORE CONNECTION</p>',
          image: ELECTRO_SEC3,
          objectPosition: 'right',
          pdf: {
            filename: '',
          },
        },
      ],
    },
    slug: 'electro',
    status: 'draft',
    id: '60b4a9e5de796b74d9177e0a',
    original: '60a4ee4da09e3808e5fd8e2e',
    createdBy: '5fd33ab1be673ff370b4957e',
    updatedBy: null,
    createdAt: '2021-05-31T09:18:29.764Z',
    updatedAt: '2021-05-31T09:18:29.775Z',
    expireAt: null,
    revision: 11,
    active: true,
    featured: null,
    channelFeatured: null,
    roles: ['EDITOR', 'ADMIN', 'TECH'],
  },
  {
    title: 'target',
    internalTitle: 'Target',
    locale: 'en',
    content: {
      boxes: [
        {
          key: 'text',
          value: 'A GLOBAL PARTNER FOR MARINE AND HEAVY INDUSTRIES',
          richText:
            '<p class="MsoNormal" style="text-align:justify"><strong><span lang="EN-US">FINCANTIERI SI</span></strong><span lang="EN-US"> activities are focused on the design, production\nand supply of innovative and integrated electrical, electronic and\nelectromechanical systems. <o:p></o:p></span></p><p class="MsoNormal" style="text-align:justify"><strong><span lang="EN-US">FINCANTIERI SI</span></strong><span lang="EN-US"> has been established to further widen\nFincantieri Group presence both in the shipbuilding segment value chain and in\nother industrial segments aiming for a more effective integration between\nmechanical, electrical and electronic capabilities. <o:p></o:p></span></p><p style="text-align: justify; ">\n\n\n\n<span lang="EN-US" style="line-height: 107%;">The focus is on shipbuilding but also on power\ngeneration and storage, steel, yards, and other sectors, with solution for navigation, for industrial and for smart power management&nbsp;</span><br></p>',
          image: {
            small: {
              id: '',
            },
          },
          pdf: {
            filename: '',
          },
        },
        {
          key: 'slider1',
          value: '',
          richText: '',
          image: TARTGET_SLIDER1,
          pdf: {
            filename: '',
          },
        },
        {
          key: 'slider2',
          value: '',
          richText: '',
          image: TARTGET_SLIDER2,
          pdf: {
            filename: '',
          },
        },
        {
          key: 'slider3',
          value: '',
          richText: '',
          image: TARTGET_SLIDER3,
          pdf: {
            filename: '',
          },
        },
        {
          key: 'slider4',
          value: '',
          richText: '',
          image: TARTGET_SLIDER4,
          pdf: {
            filename: '',
          },
        },
        {
          key: 'slider5',
          value: '',
          richText: '',
          image: TARTGET_SLIDER5,
          pdf: {
            filename: '',
          },
        },
        {
          key: 'slider6',
          value: '',
          richText: '',
          image: TARTGET_SLIDER6,
          pdf: {
            filename: '',
          },
        },
        {
          key: 'slider7',
          value: '',
          richText: '',
          image: TARTGET_SLIDER7,
          pdf: {
            filename: '',
          },
        },
        {
          key: 'sectionBox1',
          value: 'target/shipboard',
          richText:
            '<p><span style="line-height: 107%;">MARINE\nSOLUTIONS AND SHIPBOARD SYSTEMS</span><br></p>',
          image: TARTGET_SEC1,
          objectPosition: 'right',
          pdf: {
            filename: '',
          },
        },
        {
          key: 'sectionBox2',
          value: 'target/equipment',
          richText:
            '<p><span style="letter-spacing: 0.14px;">EQUIPMENT AND HARBOUR SYSTEMS</span><br></p>',
          image: TARTGET_SEC2,
          pdf: {
            filename: '',
          },
        },
        {
          key: 'sectionBox3',
          value: 'target/industrial',
          richText:
            '<p><span style="letter-spacing: 0.14px;">DESIGN AND INDUSTRIAL ENGINEERING</span><br></p>',
          image: TARTGET_SEC3,
          pdf: {
            filename: '',
          },
        },
        {
          key: 'sectionBox4',
          value: 'target/lifecycle',
          richText:
            '<p><span style="letter-spacing: 0.14px;">LIFECYCLE SERVICES</span><br></p>',
          image: TARTGET_SEC4,
          pdf: {
            filename: '',
          },
        },
      ],
    },
    slug: 'target',
    status: 'draft',
    id: '60b4d055de796b74d9178076',
    original: '60911f89d5b4fe324d3910ee',
    createdBy: '5fd33ab0be673ff370b4957a',
    updatedBy: null,
    createdAt: '2021-05-31T12:02:29.841Z',
    updatedAt: '2021-05-31T12:02:29.852Z',
    expireAt: null,
    revision: 14,
    active: true,
    featured: null,
    channelFeatured: null,
    roles: ['ADMIN', 'TECH'],
  },
  {
    title: 'propulsion',
    internalTitle: 'Target',
    locale: 'en',
    content: {
      boxes: [
        {
          key: 'text1',
          value:
            'FINCANTIERI SI PROVIDES TURN-KEY ONBOARD HYBRID ELECTRIC PROPULSION SYSTEMS',
          richText:
            '<p class="MsoNormal"><span style="font-size: 10.5pt; line-height: 107%; font-family: Helvetica, sans-serif; letter-spacing: 0.1pt; background-image: initial; background-position: initial; background-size: initial; background-repeat: initial; background-attachment: initial; background-origin: initial; background-clip: initial;">Hybrid\nElectric Systems are designed according to different power, space available,\nusage and loads required, to ensure a more eco-sustainable and environmentally\nfriendly impact with maximized performance and reduced emissions&nbsp;</span><o:p></o:p></p>',
          image: {
            small: {
              id: '',
            },
          },
          pdf: {
            filename: '',
          },
          noBrackets: true,
        },
        {
          key: 'slogan',
          value: '',
          richText:
            '<p>HYBRID ELECTRIC PROPULSION TO GARANT A REDUCED ENVIRONMENTAL IMPACT<br></p>',
          image: {
            small: {
              id: PROPULSION_TOP,
            },
          },
          pdf: {
            filename: '',
          },
        },
        {
          key: 'text2',
          value: 'FINCANTIERI SI EXPERT PARTNER FOR NAVY SHIPS',
          richText:
            '<p class="MsoNormal" style="margin-bottom: 7.5pt; text-align: justify; line-height: normal; background-image: initial; background-position: initial; background-size: initial; background-repeat: initial; background-attachment: initial; background-origin: initial; background-clip: initial;"><strong><span lang="EN-US" style="font-size: 10.5pt; font-family: Lato, serif; letter-spacing: 0.1pt;">FINCANTIERI SI</span></strong><span lang="EN-US" style="font-size: 10.5pt; font-family: Lato, serif; letter-spacing: 0.1pt;">&nbsp;is the integrator of the\nelectrical hybrid system of the Italian Navy Ships.&nbsp;</span><span lang="EN-GB" style="font-size: 10.5pt; font-family: Lato, serif; letter-spacing: 0.1pt;">On board\nelectrical system designed to optimize efficiency and reliability for Navy\nShips.</span><span style="font-size: 10.5pt; font-family: Lato, serif; letter-spacing: 0.1pt;"><o:p></o:p></span></p><p class="MsoNormal" style="margin-bottom: 7.5pt; text-align: justify; line-height: normal; background-image: initial; background-position: initial; background-size: initial; background-repeat: initial; background-attachment: initial; background-origin: initial; background-clip: initial;"><span lang="EN-US" style="font-size: 10.5pt; font-family: Lato, serif; letter-spacing: 0.1pt;">Two electric rotating machines are combined with the\ndiesel engines through the propeller shafts for:</span><span style="font-size: 10.5pt; font-family: Lato, serif; letter-spacing: 0.1pt;"><o:p></o:p></span></p><ul type="disc">\n <li class="MsoNormal" style="text-align: justify; line-height: normal; background-image: initial; background-position: initial; background-size: initial; background-repeat: initial; background-attachment: initial; background-origin: initial; background-clip: initial;"><span lang="EN-US" style="font-size:\n     10.5pt;font-family:&quot;Helvetica&quot;,sans-serif;mso-fareast-font-family:&quot;Times New Roman&quot;;\n     letter-spacing:.1pt;mso-ansi-language:EN-US;mso-fareast-language:IT">Electrical\n     propulsion – providing power;</span><span style="font-size:10.5pt;\n     font-family:&quot;Helvetica&quot;,sans-serif;mso-fareast-font-family:&quot;Times New Roman&quot;;\n     letter-spacing:.1pt;mso-fareast-language:IT"><o:p></o:p></span></li>\n <li class="MsoNormal" style="text-align: justify; line-height: normal; background-image: initial; background-position: initial; background-size: initial; background-repeat: initial; background-attachment: initial; background-origin: initial; background-clip: initial;"><span lang="EN-US" style="font-size:\n     10.5pt;font-family:&quot;Helvetica&quot;,sans-serif;mso-fareast-font-family:&quot;Times New Roman&quot;;\n     letter-spacing:.1pt;mso-ansi-language:EN-US;mso-fareast-language:IT">Electrical\n     generation – deducting power;</span><span style="font-size:10.5pt;\n     font-family:&quot;Helvetica&quot;,sans-serif;mso-fareast-font-family:&quot;Times New Roman&quot;;\n     letter-spacing:.1pt;mso-fareast-language:IT"><o:p></o:p></span></li>\n <li class="MsoNormal" style="text-align: justify; line-height: normal; background-image: initial; background-position: initial; background-size: initial; background-repeat: initial; background-attachment: initial; background-origin: initial; background-clip: initial;"><span lang="EN-US" style="font-size:\n     10.5pt;font-family:&quot;Helvetica&quot;,sans-serif;mso-fareast-font-family:&quot;Times New Roman&quot;;\n     letter-spacing:.1pt;mso-ansi-language:EN-US;mso-fareast-language:IT">Peak\n     shaving – stabilizing power.<br>\n     <!--[if !supportLineBreakNewLine]--><br>\n     <!--[endif]--></span><span style="font-size:10.5pt;font-family:&quot;Helvetica&quot;,sans-serif;\n     mso-fareast-font-family:&quot;Times New Roman&quot;;letter-spacing:.1pt;mso-fareast-language:\n     IT"><o:p></o:p></span></li>\n</ul><p class="MsoNormal" style="margin-bottom: 7.5pt; text-align: justify; line-height: normal; background-image: initial; background-position: initial; background-size: initial; background-repeat: initial; background-attachment: initial; background-origin: initial; background-clip: initial;"><span lang="EN-US" style="font-size: 10.5pt; font-family: Lato, serif; letter-spacing: 0.1pt;">The electric power chain includes variable frequency\ndrives, transformers, switchboards and power drive systems for thruster\npropellers.</span><span style="font-size: 10.5pt; font-family: Lato, serif; letter-spacing: 0.1pt;"><o:p></o:p></span></p><p class="MsoNormal" style="margin-bottom: 7.5pt; text-align: justify; line-height: normal; background-image: initial; background-position: initial; background-size: initial; background-repeat: initial; background-attachment: initial; background-origin: initial; background-clip: initial;"><span lang="EN-US" style="font-size: 10.5pt; font-family: Lato, serif; letter-spacing: 0.1pt;">Navy particular features as high shock-proof\nrequirements and others.</span><span style="font-size: 10.5pt; font-family: Lato, serif; letter-spacing: 0.1pt;"><o:p></o:p></span></p><p class="MsoNormal" style="text-align: justify; ">\n\n\n\n\n\n\n\n\n\n<span lang="EN-US" style="font-size: 10.5pt; line-height: 107%; font-family: Lato, serif; letter-spacing: 0.1pt;">Additional 50/60 Hz conversion system for Stanag\nwar network suitable for heavy impulsive loads.</span><br></p>',
          image: {
            small: {
              id: '',
            },
          },
          pdf: {
            filename: '',
          },
        },
        {
          key: 'card',
          value: '',
          richText:
            '<p class="MsoNormal" style="margin-bottom: 7.5pt; line-height: normal; background-image: initial; background-position: initial; background-size: initial; background-repeat: initial; background-attachment: initial; background-origin: initial; background-clip: initial;"><strong><span lang="EN-GB" style="font-size: 10.5pt; font-family: Lato, serif; letter-spacing: 0.1pt;">SHIP: LHD (Landing Helicopter Dock)</span></strong><span style="font-size: 10.5pt; font-family: Lato, serif; letter-spacing: 0.1pt;"><o:p></o:p></span></p><p class="MsoNormal" style="margin-bottom: 7.5pt; line-height: normal; background-image: initial; background-position: initial; background-size: initial; background-repeat: initial; background-attachment: initial; background-origin: initial; background-clip: initial;"><strong><span lang="EN-GB" style="font-size: 10.5pt; font-family: Lato, serif; letter-spacing: 0.1pt;">STANDARD</span></strong><span lang="EN-GB" style="font-size: 10.5pt; font-family: Lato, serif; letter-spacing: 0.1pt;">:&nbsp;Rinamil, Stanag, IEC</span><span style="font-size: 10.5pt; font-family: Lato, serif; letter-spacing: 0.1pt;"><o:p></o:p></span></p><p class="MsoListParagraphCxSpFirst" style="margin-left:0cm;mso-add-space:auto;\ntext-align:justify">\n\n\n\n</p><p class="MsoNormal" style="margin-bottom: 7.5pt; line-height: normal; background-image: initial; background-position: initial; background-size: initial; background-repeat: initial; background-attachment: initial; background-origin: initial; background-clip: initial;"><strong><span lang="EN-GB" style="font-size: 10.5pt; font-family: Lato, serif; letter-spacing: 0.1pt;">TYPE</span></strong><span lang="EN-GB" style="font-size: 10.5pt; font-family: Lato, serif; letter-spacing: 0.1pt;">:&nbsp;CODLOG – combined diesel or diesel-electric or gas turbine</span><span style="font-size: 10.5pt; font-family: Lato, serif; letter-spacing: 0.1pt;"><o:p></o:p></span></p>',
          image: PROPULSION_CARD1,
          pdf: PROPULSION_PDF1,
        },
        {
          key: 'card',
          value: '',
          richText:
            '<p class="MsoNormal" style="margin-bottom: 7.5pt; line-height: normal; background-image: initial; background-position: initial; background-size: initial; background-repeat: initial; background-attachment: initial; background-origin: initial; background-clip: initial;"><strong><span lang="EN-GB" style="font-size: 10.5pt; font-family: Lato, serif; letter-spacing: 0.1pt;">SHIP: LSS (Logistic Support Ship)</span></strong><span style="font-size: 10.5pt; font-family: Lato, serif; letter-spacing: 0.1pt;"><o:p></o:p></span></p><p class="MsoNormal" style="margin-bottom: 7.5pt; line-height: normal; background-image: initial; background-position: initial; background-size: initial; background-repeat: initial; background-attachment: initial; background-origin: initial; background-clip: initial;"><strong><span lang="EN-GB" style="font-size: 10.5pt; font-family: Lato, serif; letter-spacing: 0.1pt;">STANDARD</span></strong><span lang="EN-GB" style="font-size: 10.5pt; font-family: Lato, serif; letter-spacing: 0.1pt;">:&nbsp;Rinamil, Stanag, IEC</span><span style="font-size: 10.5pt; font-family: Lato, serif; letter-spacing: 0.1pt;"><o:p></o:p></span></p><p class="MsoListParagraphCxSpFirst" style="margin-left:0cm;mso-add-space:auto;\ntext-align:justify">\n\n\n\n</p><p class="MsoNormal" style="margin-bottom: 7.5pt; line-height: normal; background-image: initial; background-position: initial; background-size: initial; background-repeat: initial; background-attachment: initial; background-origin: initial; background-clip: initial;"><strong><span lang="EN-GB" style="font-size: 10.5pt; font-family: Lato, serif; letter-spacing: 0.1pt;">TYPE</span></strong><span lang="EN-GB" style="font-size: 10.5pt; font-family: Lato, serif; letter-spacing: 0.1pt;">:&nbsp;CODLAD – combined diesel-electric and diesel</span><span style="font-size: 10.5pt; font-family: Lato, serif; letter-spacing: 0.1pt;"><o:p></o:p></span></p>',
          image: PROPULSION_CARD2,

          pdf: PROPULSION_PDF2,
        },
        {
          key: 'card',
          value: '',
          richText:
            '<p class="MsoNormal" style="margin-bottom: 7.5pt; line-height: normal; background-image: initial; background-position: initial; background-size: initial; background-repeat: initial; background-attachment: initial; background-origin: initial; background-clip: initial;"><strong><span lang="EN-US" style="font-size: 10.5pt; font-family: Lato, serif; letter-spacing: 0.1pt;">SHIP: PPA (Multipurpose Offshore Patrol Vessel)</span></strong><span style="font-size: 10.5pt; font-family: Lato, serif; letter-spacing: 0.1pt;"><o:p></o:p></span></p><p class="MsoNormal" style="margin-bottom: 7.5pt; line-height: normal; background-image: initial; background-position: initial; background-size: initial; background-repeat: initial; background-attachment: initial; background-origin: initial; background-clip: initial;"><strong><span lang="EN-GB" style="font-size: 10.5pt; font-family: Lato, serif; letter-spacing: 0.1pt;">STANDARD</span></strong><span lang="EN-GB" style="font-size: 10.5pt; font-family: Lato, serif; letter-spacing: 0.1pt;">:&nbsp;Rinamil, Stanag, IEC</span><span style="font-size: 10.5pt; font-family: Lato, serif; letter-spacing: 0.1pt;"><o:p></o:p></span></p><p class="MsoListParagraphCxSpFirst" style="margin-left:0cm;mso-add-space:auto;\ntext-align:justify">\n\n\n\n</p><p class="MsoNormal" style="margin-bottom: 7.5pt; line-height: normal; background-image: initial; background-position: initial; background-size: initial; background-repeat: initial; background-attachment: initial; background-origin: initial; background-clip: initial;"><strong><span lang="EN-GB" style="font-size: 10.5pt; font-family: Lato, serif; letter-spacing: 0.1pt;">TYPE</span></strong><span lang="EN-GB" style="font-size: 10.5pt; font-family: Lato, serif; letter-spacing: 0.1pt;">:&nbsp;CODAG – combined diesel and gas turbine or electric</span><span style="font-size: 10.5pt; font-family: Lato, serif; letter-spacing: 0.1pt;"><o:p></o:p></span></p>',
          image: PROPULSION_CARD3,

          pdf: PROPULSION_PDF3,
        },
        {
          key: 'sectionBox1',
          value: 'target/shipboard/energy',
          richText: '<p>ENERGY STORAGE SYSTEMS</p>',
          image: PROPULSION_SEC1,
          pdf: {
            filename: '',
          },
          objectPosition: 'right',
        },
        {
          key: 'sectionBox2',
          value: 'target/shipboard/electro',
          richText: '<p>ELECTRO-MECHANICAL SYSTEMS</p>',
          image: PROPULSION_SEC2,

          pdf: {
            filename: '',
          },
        },
        {
          key: 'sectionBox3',
          value: 'target/shipboard/shiptoshore',
          richText: '<p>SHIP-TO-SHORE CONNECTION</p>',
          image: PROPULSION_SEC3,
          objectPosition: 'right',
          pdf: {
            filename: '',
          },
        },
      ],
    },
    slug: 'propulsion',
    status: 'draft',
    id: '60b639d0de796b74d9178544',
    original: '60a4d352a09e3808e5fd8cb5',
    createdBy: '5fd33ab1be673ff370b4957e',
    updatedBy: null,
    createdAt: '2021-06-01T13:44:48.800Z',
    updatedAt: '2021-06-01T13:44:48.816Z',
    expireAt: null,
    revision: 10,
    active: true,
    channelFeatured: null,
    roles: ['EDITOR', 'ADMIN', 'TECH'],
  },
];
